/* eslint-disable import/order */
import { MenuIdPlans } from '@jira/navigation-apps__constants/src/MenuIdPlans.tsx';
import { SidebarIdPlanSettings } from '@jira/navigation-apps__constants/src/SidebarIdPlanSettings.tsx';
import {
	advancedRoadmapsPlanPageInitialChecksResource,
	advancedRoadmapsReduxStoreStateResource,
} from '@jira/router-resources__advanced-roadmaps-plan/src/advancedRoadmapsPlanPageInitialChecksResource.tsx';
import { getPlansBacklogResource } from '@jira/router-resources__advanced-roadmaps-plan/src/plansBacklogResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { planLayout } from '@jira/platform__layouts-jira-plan-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { composeLayouts } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import {
	getNavigationResources,
	getNavigationSidebarPlanResources,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { softwarePlanSettingsPermissionsRoute } from '@jira/router-routes__advanced-roadmaps-routes/src/softwarePlanSettingsPermissionsRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import PlanSettingsPermissionsPage, {
	LazyPlanSettingsPermissions,
} from './ui/plan-settings-permissions/index.tsx';

export const softwarePlanSettingsPermissionsRouteEntry: Route = createEntry(
	softwarePlanSettingsPermissionsRoute,
	() => ({
		group: 'software',
		// eslint-disable-next-line no-restricted-syntax
		component: PlanSettingsPermissionsPage,
		layout: composeLayouts(globalLayout, planLayout),

		resources: [
			...getNavigationResources(),
			...getNavigationSidebarPlanResources(),
			advancedRoadmapsPlanPageInitialChecksResource,
			...getPlansBacklogResource(),
			advancedRoadmapsReduxStoreStateResource,
		],

		preloadOptions: {
			earlyChunks: ['advanced-roadmaps-early-entry'],
		},

		navigation: {
			sidebarId: SidebarIdPlanSettings,
			menuId: MenuIdPlans,
		},

		forPaint: [LazyAtlassianNavigation, LazyPlanSettingsPermissions],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
